export enum FACT_NAMES_BOOLEAN {
  IS_REPEAT_BORROWER = "IS_REPEAT_BORROWER",
}
